import { render, staticRenderFns } from "./faq-list.vue?vue&type=template&id=1d0a39be&scoped=true&"
import script from "./faq-list.vue?vue&type=script&lang=js&"
export * from "./faq-list.vue?vue&type=script&lang=js&"
import style0 from "./faq-list.vue?vue&type=style&index=0&id=1d0a39be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a39be",
  null
  
)

export default component.exports